module.exports = __webpack_public_path__ + "static/media/chat.0d186b91.svg";